module.exports = __webpack_public_path__ + "static/img/encore1.992e0678.png";